import { render, staticRenderFns } from "./V2CollectionProducts.vue?vue&type=template&id=6ffc7ab4&scoped=true&"
import script from "./V2CollectionProducts.vue?vue&type=script&lang=js&"
export * from "./V2CollectionProducts.vue?vue&type=script&lang=js&"
import style0 from "./V2CollectionProducts.vue?vue&type=style&index=0&id=6ffc7ab4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffc7ab4",
  null
  
)

export default component.exports